import React, { useState } from 'react';
import svgPaths from "../../../../imports/svg-qd1swb8vwf";

// Background Layers (Blobs)
const YellowBg = ({ left, top }: { left: number, top: number }) => (
  <div className="absolute h-[75px] w-[76px]" style={{ left: `${left}px`, top: `${top}px` }} data-name="Yellow BG">
    <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 76 75">
      <g id="Yellow BG">
        <g filter="url(#filter0_f_58_732)" id="Ellipse 2361" opacity="0">
          <ellipse cx="38" cy="37.5" fill="url(#paint0_linear_58_732)" rx="38" ry="37.5" />
        </g>
      </g>
      <defs>
        <filter colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse" height="-inf" id="filter0_f_58_732" width="-inf" x="inf" y="inf">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
          <feGaussianBlur result="effect1_foregroundBlur_58_732" stdDeviation="75" />
        </filter>
        <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_58_732" x1="38" x2="38" y1="0" y2="75">
          <stop stopColor="#0BA29B" />
          <stop offset="1" stopColor="#43B48D" />
        </linearGradient>
      </defs>
    </svg>
  </div>
);

// Generate background grid
const BackgroundGrid = () => {


  // Hardcoded positions based on Figma import logic to preserve exact layout
  const positions = [
    // Column 1 (x=0)
    { x: 0, y: 0 }, { x: 0, y: 75 }, { x: 0, y: 150 }, { x: 0, y: 225 },
    // Column 2 (x=76)
    { x: 76, y: 0 }, { x: 76, y: 75 }, { x: 76, y: 150 }, { x: 76, y: 225 },
    // Column 3 (x=152)
    { x: 152, y: 0 }, { x: 152, y: 75 }, { x: 152, y: 150 }, { x: 152, y: 225 },
    // Column 4 (x=228)
    { x: 228, y: 0 }, { x: 228, y: 75 }, { x: 228, y: 150 }, { x: 228, y: 225 },
    // Column 5 (x=304)
    { x: 304, y: 0 }, { x: 304, y: 75 }, { x: 304, y: 150 }, { x: 304, y: 225 },
    // Column 6 (x=380)
    { x: 380, y: 0 }, { x: 380, y: 75 }, { x: 380, y: 150 }, { x: 380, y: 225 },
    // Column 7 (x=456)
    { x: 456, y: 0 }, { x: 456, y: 75 }, { x: 456, y: 150 }, { x: 456, y: 225 },
    // Column 8 (x=532)
    { x: 532, y: 0 }, { x: 532, y: 75 }, { x: 532, y: 150 }, { x: 532, y: 225 },
    // Column 9 (x=608)
    { x: 608, y: 0 }, { x: 608, y: 75 }, { x: 608, y: 150 }, { x: 608, y: 225 },
    // Column 10 (x=684)
    { x: 684, y: 0 }, { x: 684, y: 75 }, { x: 684, y: 150 }, { x: 684, y: 225 },
    // Column 11 (x=760)
    { x: 760, y: 0 }, { x: 760, y: 75 }, { x: 760, y: 150 }, { x: 760, y: 225 },
    // Column 12 (x=836)
    { x: 836, y: 0 }, { x: 836, y: 75 }, { x: 836, y: 150 }, { x: 836, y: 225 },
    // Column 13 (x=912)
    { x: 912, y: 0 }, { x: 912, y: 75 }, { x: 912, y: 150 }, { x: 912, y: 225 },
    // Column 14 (x=988)
    { x: 988, y: 0 }, { x: 988, y: 75 }, { x: 988, y: 150 }, { x: 988, y: 225 },
    // Column 15 (x=1064)
    { x: 1064, y: 0 }, { x: 1064, y: 75 }, { x: 1064, y: 150 }, { x: 1064, y: 225 },
    // Column 16 (x=1140)
    { x: 1140, y: 0 }, { x: 1140, y: 75 }, { x: 1140, y: 150 }, { x: 1140, y: 225 },
    // Column 17 (x=1216)
    { x: 1216, y: 0 }, { x: 1216, y: 75 }, { x: 1216, y: 150 }, { x: 1216, y: 225 },
    // Column 18 (x=1292)
    { x: 1292, y: 0 }, { x: 1292, y: 75 }, { x: 1292, y: 150 }, { x: 1292, y: 225 },
    // Column 19 (x=1368)
    { x: 1368, y: 0 }, { x: 1368, y: 75 }, { x: 1368, y: 150 }, { x: 1368, y: 225 },
  ];

  return (
    <div className="absolute h-[256px] left-0 overflow-clip top-0 w-full">
      {positions.map((pos, i) => (
        <YellowBg key={i} left={pos.x} top={pos.y} />
      ))}
    </div>
  );
};

const AiIcon = () => (
  <div className="relative shrink-0 size-[18px]" data-name="ix:ai">
    <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 18 18">
      <g id="ix:ai">
        <path d={svgPaths.p21edb380} fill="var(--fill-0, #101928)" id="Vector" />
      </g>
    </svg>
  </div>
);

const ArrowRightIcon = () => (
  <div className="relative shrink-0 size-[24px]" data-name="Frame">
    <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 24 24">
      <g id="Frame">
        <path d="M5 12H19" id="Vector" stroke="var(--stroke-0, white)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" />
        <path d="M12 5L19 12L12 19" id="Vector_2" stroke="var(--stroke-0, white)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" />
      </g>
    </svg>
  </div>
);

const DropdownIcon = () => (
  <div className="relative shrink-0 size-[16px]" data-name="Frame">
    <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 16 16">
      <g id="Frame">
        <path d="M4 6L8 10L12 6" id="Vector" stroke="var(--stroke-0, #101928)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.25" />
      </g>
    </svg>
  </div>
);

interface AiHeroProps {
  onGenerate?: (prompt: string) => void;
}

export const AiHero = ({ onGenerate }: AiHeroProps) => {
  const [inputValue, setInputValue] = useState('');

  const handleAction = () => {
    if (onGenerate) {
      onGenerate(inputValue);
    }
  };

  return (
    <div className="h-[256px] overflow-clip relative rounded-[8px] shrink-0 w-full bg-[#FAFAFA]">

      {/* Decorative Blobs */}
      <div className="absolute flex h-[285.872px] items-center justify-center left-[175.79px] top-[-15.01px] w-[157.459px]" style={{ "--transform-inner-width": "300", "--transform-inner-height": "150" } as React.CSSProperties}>
        <div className="flex-none rotate-[23.797deg]">
          <div className="h-[293.652px] relative w-[42.592px]">
            <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 32 32">
              <g id="Rectangle 34624130"></g>
            </svg>
          </div>
        </div>
      </div>
      <div className="absolute h-[385px] left-[-42px] top-[-271px] w-[513px]">
        <div className="absolute inset-[-129.87%_-97.47%]">
          <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 1513 1385">
            <g filter="url(#filter0_f_58_750)" id="Ellipse 20">
              <ellipse cx="756.5" cy="692.5" fill="var(--fill-0, #F9D495)" rx="256.5" ry="192.5" />
            </g>
            <defs>
              <filter colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse" height="1385" id="filter0_f_58_750" width="1513" x="0" y="0">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
                <feGaussianBlur result="effect1_foregroundBlur_58_750" stdDeviation="250" />
              </filter>
            </defs>
          </svg>
        </div>
      </div>
      <div className="absolute h-[369px] right-0 top-[-224px] w-[573px]">
        <div className="absolute inset-[-135.5%_-87.26%]">
          <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 1573 1369">
            <g filter="url(#filter0_f_58_735)" id="Ellipse 21">
              <ellipse cx="786.5" cy="684.5" fill="var(--fill-0, #BEA4F3)" rx="286.5" ry="184.5" />
            </g>
            <defs>
              <filter colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse" height="1369" id="filter0_f_58_735" width="1573" x="0" y="0">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
                <feGaussianBlur result="effect1_foregroundBlur_58_735" stdDeviation="250" />
              </filter>
            </defs>
          </svg>
        </div>
      </div>

      {/* Grid Pattern */}
      <BackgroundGrid />

      {/* Hero Content - Left Aligned */}
      <div className="absolute content-stretch flex flex-col gap-[16px] items-start left-0 top-1/2 -translate-y-1/2 w-full max-w-[1349px] px-8">

        {/* Text Section */}
        <div className="content-stretch flex flex-col gap-[20px] items-start relative shrink-0 w-full">
          <div className="content-stretch flex items-center relative shrink-0 w-full">
            <div className="basis-0 content-stretch flex flex-col gap-[8px] grow items-start min-h-px min-w-px relative shrink-0">
              <p className="font-sans font-extrabold leading-[normal] relative shrink-0 text-[#1d2739] text-[28px] w-full" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
                Turn your thoughts into templates instantly.
              </p>
              <p className="font-sans font-medium leading-[24px] relative shrink-0 text-[#667185] text-[14px] tracking-[0.14px] w-full" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
                Type an idea. Watch a template appear like magic. Customize and make it yours in moments.
              </p>
            </div>
          </div>

          {/* Search Input Section */}
          <div className="content-stretch flex gap-[16px] items-center relative shrink-0 w-full">
            <div className="bg-[rgba(255,255,255,0.3)] content-stretch flex h-[48px] items-center overflow-clip px-[12px] py-[3px] relative rounded-[12px] shrink-0 w-full grow" data-name="Search bar">
              <div className="content-stretch flex gap-[8px] items-center relative size-full">
                <AiIcon />
                <input
                  type="text"
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && handleAction()}
                  className="bg-transparent border-none outline-none font-sans font-medium text-[13px] h-full w-full text-[#1d2739] placeholder:text-[#667185]"
                  placeholder="Got an idea? Drop it here and let the template magic begin!"
                  style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}
                />
              </div>
            </div>

            {/* Action Button */}
            <div
              onClick={handleAction}
              className="bg-[#30a84b] content-stretch flex gap-[4px] items-center justify-center px-[16px] py-[14px] relative rounded-[6px] shrink-0 size-[44px] cursor-pointer hover:bg-[#288c3e] transition-colors"
              data-name="Primary - Sm"
            >
              <ArrowRightIcon />
            </div>
          </div>
        </div>

        {/* Dropdowns */}
        <div className="content-stretch flex gap-[12px] items-start relative shrink-0">
          {/* Landscape */}
          <div className="bg-[rgba(255,255,255,0.3)] content-stretch flex items-center justify-between p-[8px] relative rounded-[4px] shrink-0 w-[122px] cursor-pointer">
            <p className="font-sans font-medium leading-[normal] relative shrink-0 text-[#101928] text-[13px] text-nowrap whitespace-pre" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
              Landscape
            </p>
            <DropdownIcon />
          </div>

          {/* 16:9 */}
          <div className="bg-[rgba(255,255,255,0.3)] content-stretch flex items-center justify-between p-[8px] relative rounded-[4px] shrink-0 w-[89px] cursor-pointer">
            <p className="font-sans font-medium leading-[normal] relative shrink-0 text-[#101928] text-[13px] text-nowrap whitespace-pre" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
              16:9
            </p>
            <DropdownIcon />
          </div>
        </div>
      </div>
    </div>
  );
};

